import { adminApi } from "../../lib/axios";

export interface BrandRewardConfigurationRule {
  id: string;
  reward: string;
  rewardTypes: string[];
  revenueThreshold: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateBrandRewardRuleInput
  extends Omit<
    BrandRewardConfigurationRule,
    "id" | "createdAt" | "updatedAt"
  > {}

export interface UpdateBrandRewardRuleInput
  extends Partial<
    Omit<BrandRewardConfigurationRule, "id" | "createdAt" | "updatedAt">
  > {}

export const adminBrandRewardsService = {
  async list(): Promise<BrandRewardConfigurationRule[]> {
    try {
      const res = await adminApi.get("brand-rewards/config");
      return res.data.data || res.data.items || res.data || [];
    } catch (error: any) {
      console.error("Error fetching brand reward conditions:", error);
      return [];
    }
  },

  async create(
    input: CreateBrandRewardRuleInput
  ): Promise<BrandRewardConfigurationRule> {
    const res = await adminApi.post("brand-rewards/config", input);
    return res.data.data || res.data.item || res.data;
  },

  async update(
    id: string,
    input: UpdateBrandRewardRuleInput
  ): Promise<BrandRewardConfigurationRule> {
    const res = await adminApi.patch(`brand-rewards/config/${id}`, input);
    return res.data.data || res.data.item || res.data;
  },

  async remove(id: string): Promise<{ success: boolean; message?: string }> {
    const res = await adminApi.delete(`brand-rewards/config/${id}`);
    return { success: true, message: res.data?.message };
  },
};

export default adminBrandRewardsService;
